import _ from 'lodash';
import moment from 'moment';

const transformRequest = (jsonData = {}) =>
  Object.entries(jsonData)
    .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join('&');

export class FormMapper {
  static mapFormToApi(form) {
    let data = {};
    if (form.inspection?.report?.expertise)
      _.set(form, 'inspection.report.expertise.dateExpertise', ['date', moment().format('YYYY-MM-DD HH:mm:ss')]);
    data.inspection = JSON.stringify(form.inspection);
    data.status = form.status;
    data = transformRequest(data);
    return data;
  }
}
